import { http } from '@/services/http';
import { parseFromToISO } from '@/shared/lib/date/parseFromToISO';

type QueryFormat = 'json' | 'csv';

const ACCEPT_HEADERS: Record<QueryFormat, string> = {
  json: 'application/json',
  csv: 'text/csv'
};

const parseToISO = (to: string | null | undefined): string | undefined => {
  if (!to) return undefined;
  const parsed = new Date(to);
  return Number.isNaN(parsed.getTime()) ? undefined : parsed.toISOString();
};

const queryApi = async (
  queryId: string,
  from: string | undefined,
  format: QueryFormat,
  to?: string | null
) => {
  const parsedFrom = parseFromToISO(from);
  const parsedTo = parseToISO(to);
  const toParam = parsedTo ? `&to=${parsedTo}` : '';
  const response = await http.internal.get(
    `/duck/${queryId}?mode=turbo&from=${parsedFrom}${toParam}`,
    { headers: { Accept: ACCEPT_HEADERS[format] } }
  );

  if (response.status !== 200) {
    throw new Error(`Query execution failed for ID '${queryId}' with status ${response.status}`);
  }

  if (format === 'csv') {
    return typeof response.data === 'string' ? response.data : String(response.data ?? '');
  }

  const { data } = response;
  return Array.isArray(data) ? data : [data];
};

export const queryApiById = async (
  queryId: string,
  from: string | undefined,
  to?: string | null
) => {
  return queryApi(queryId, from, 'json', to);
};

export const queryApiByIdString = async (queryId: string, from?: string, to?: string | null) => {
  return queryApi(queryId, from, 'csv', to) as Promise<string>;
};
